import styled from 'styled-components';
import { space, MarginProps } from 'styled-system';

const Margin = styled.div<MarginProps>(space);

export default Margin;
